import RequirementFull from 'features/requirements/dtos/RequirementFullDTO';
import Alert from 'features/shared/alerts/components/Alert';
import React from 'react';
import { useTranslation } from 'react-i18next';

const allowedTypes = ["ZMENA_EMAILU", "PRECHODEMAILKOMUNIKACE"];
const allowedStates = ["CEKANI_NA_OCERENI", "CEKANI_NA_OVERENI"];
interface Props {
  requirement: RequirementFull;
}

const ConfirmEmailAlert = ({ requirement }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  if (
    allowedTypes.includes(requirement.requirementType?.code!)  &&
    allowedStates.includes(requirement.actualState?.code!) 
  ) {
    return (
      <Alert
        alertObj={{
          alertType: "Info",
          message: tLabels("confirmEmailAlert.message"),
        }}
        closable
      />
    );
  } else {
    return null;
  }
}

export default ConfirmEmailAlert;
